import { render, staticRenderFns } from "./MarketPayTrends.vue?vue&type=template&id=334afc64&"
import script from "./MarketPayTrends.vue?vue&type=script&lang=js&"
export * from "./MarketPayTrends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports